"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.browser = exports.ie = exports.date = exports.dom = exports.utils = exports.url = exports.string = exports.uniqueId = exports.functionModule = exports.array = exports.autoFillUrl = exports.isEmptyValue = exports.isEmptyObject = exports.isAsyncFunction = exports.isFunction = exports.isFile = exports.isDate = exports.isObject = exports.isUndefined = exports.isNumber = exports.isString = exports.isArray = exports.type = exports.trim = exports.cancelReportComponentUsage = exports.reportComponentUsage = exports.cancelReportUsage = exports.reportUsage = exports.tcssReport = exports.report = exports.isReactNode = exports.renderIf = exports.formatProps = exports.checkCssVersion = exports.genDecorate = exports.withMark = exports.setComponentMark = exports.globalProps = exports.PropTypes = exports.removeUndefined = exports.objectAssign = exports.adjustValue = exports.loadJs = exports.loadCss = exports.getUniqueId = exports.throttle = exports.debounce = exports.noop = exports.pxVal = exports.getScrollTop = exports.removeClassName = exports.addClassName = exports.getStyle = exports.closest = exports.joinDate = exports.splitDate = exports.nodeTree = exports.getOSName = exports.initFocusManager = exports.isIE = exports.getBrowserVersion = exports.cloneArray = exports.indexOf = undefined;

var _abandon_and_compat = require("./abandon_and_compat");

var _abandon_and_compat2 = _interopRequireDefault(_abandon_and_compat);

var _index = require("./js/array/index");

var _index2 = _interopRequireDefault(_index);

var _index3 = require("./js/browser/index");

var _index4 = _interopRequireDefault(_index3);

var _index5 = require("./js/data/index");

var _index6 = _interopRequireDefault(_index5);

var _index7 = require("./js/date/index");

var _index8 = _interopRequireDefault(_index7);

var _index9 = require("./js/dom/index");

var _index10 = _interopRequireDefault(_index9);

var _index11 = require("./js/function/index");

var _index12 = _interopRequireDefault(_index11);

var _index13 = require("./js/key/index");

var _index14 = _interopRequireDefault(_index13);

var _index15 = require("./js/load/index");

var _index16 = _interopRequireDefault(_index15);

var _index17 = require("./js/number/index");

var _index18 = _interopRequireDefault(_index17);

var _index19 = require("./js/object/index");

var _index20 = _interopRequireDefault(_index19);

var _index21 = require("./js/react/index");

var _index22 = _interopRequireDefault(_index21);

var _index23 = require("./js/report/index");

var _index24 = _interopRequireDefault(_index23);

var _index25 = require("./js/string/index");

var _index26 = _interopRequireDefault(_index25);

var _index27 = require("./js/type/index");

var _index28 = _interopRequireDefault(_index27);

var _index29 = require("./js/url/index");

var _index30 = _interopRequireDefault(_index29);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// 将对应的模块的default也加入到默认导出的数据中
var addValueForObject = function addValueForObject() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var target = arguments[1];

    var targetData = target || exportDefaultData,
        key = "";
    for (key in data) {
        targetData[key] = data[key];
    }
}; // 各个模块的default默认也做export导出

// 废弃模块

var exportDefaultData = {};

// 数组相关
var indexOf = _index2.default.indexOf,
    cloneArray = _index2.default.cloneArray;
exports.indexOf = indexOf;
exports.cloneArray = cloneArray;

addValueForObject(_index2.default);

// 浏览器相关
var getBrowserVersion = _index4.default.getBrowserVersion,
    isIE = _index4.default.isIE,
    initFocusManager = _index4.default.initFocusManager,
    getOSName = _index4.default.getOSName;
exports.getBrowserVersion = getBrowserVersion;
exports.isIE = isIE;
exports.initFocusManager = initFocusManager;
exports.getOSName = getOSName;

addValueForObject(_index4.default);

// 数据相关
var nodeTree = _index6.default.nodeTree;
exports.nodeTree = nodeTree;

addValueForObject(_index6.default);

// 日期相关
var splitDate = _index8.default.splitDate,
    joinDate = _index8.default.joinDate;
exports.splitDate = splitDate;
exports.joinDate = joinDate;

addValueForObject(_index8.default);

// dom相关
var closest = _index10.default.closest,
    getStyle = _index10.default.getStyle,
    addClassName = _index10.default.addClassName,
    removeClassName = _index10.default.removeClassName,
    getScrollTop = _index10.default.getScrollTop,
    pxVal = _index10.default.pxVal;
exports.closest = closest;
exports.getStyle = getStyle;
exports.addClassName = addClassName;
exports.removeClassName = removeClassName;
exports.getScrollTop = getScrollTop;
exports.pxVal = pxVal;

addValueForObject(_index10.default);

// function相关
var noop = _index12.default.noop,
    debounce = _index12.default.debounce,
    throttle = _index12.default.throttle;
exports.noop = noop;
exports.debounce = debounce;
exports.throttle = throttle;

addValueForObject(_index12.default);

// key相关
var getUniqueId = _index14.default.getUniqueId;
exports.getUniqueId = getUniqueId;

addValueForObject(_index14.default);

// load相关
var loadCss = _index16.default.loadCss,
    loadJs = _index16.default.loadJs;
exports.loadCss = loadCss;
exports.loadJs = loadJs;

addValueForObject(_index16.default);

// number相关
var adjustValue = _index18.default.adjustValue;
exports.adjustValue = adjustValue;

addValueForObject(_index18.default);

// object相关
var objectAssign = _index20.default.objectAssign,
    removeUndefined = _index20.default.removeUndefined;
exports.objectAssign = objectAssign;
exports.removeUndefined = removeUndefined;

addValueForObject(_index20.default);

// react 相关
var PropTypes = _index22.default.PropTypes,
    globalProps = _index22.default.globalProps,
    setComponentMark = _index22.default.setComponentMark,
    withMark = _index22.default.withMark,
    genDecorate = _index22.default.genDecorate,
    checkCssVersion = _index22.default.checkCssVersion,
    formatProps = _index22.default.formatProps,
    renderIf = _index22.default.renderIf,
    isReactNode = _index22.default.isReactNode;
exports.PropTypes = PropTypes;
exports.globalProps = globalProps;
exports.setComponentMark = setComponentMark;
exports.withMark = withMark;
exports.genDecorate = genDecorate;
exports.checkCssVersion = checkCssVersion;
exports.formatProps = formatProps;
exports.renderIf = renderIf;
exports.isReactNode = isReactNode;

addValueForObject(_index22.default);

// report 相关

// 兼容下旧的导出，旧的report是整个_report
addValueForObject(_index24.default, _index24.default.report);
_index24.default.report.setComponentSign = _abandon_and_compat2.default.setComponentSign;
var report = _index24.default.report,
    tcssReport = _index24.default.tcssReport,
    reportUsage = _index24.default.reportUsage,
    cancelReportUsage = _index24.default.cancelReportUsage,
    reportComponentUsage = _index24.default.reportComponentUsage,
    cancelReportComponentUsage = _index24.default.cancelReportComponentUsage;
exports.report = report;
exports.tcssReport = tcssReport;
exports.reportUsage = reportUsage;
exports.cancelReportUsage = cancelReportUsage;
exports.reportComponentUsage = reportComponentUsage;
exports.cancelReportComponentUsage = cancelReportComponentUsage;

addValueForObject(_index24.default);

// string 相关
var trim = _index26.default.trim;
exports.trim = trim;

addValueForObject(_index26.default);

// type 相关

// 兼容下旧的导出，旧的type是整个_type
addValueForObject(_index28.default, _index28.default.type);
var type = _index28.default.type,
    isArray = _index28.default.isArray,
    isString = _index28.default.isString,
    isNumber = _index28.default.isNumber,
    isUndefined = _index28.default.isUndefined,
    isObject = _index28.default.isObject,
    isDate = _index28.default.isDate,
    isFile = _index28.default.isFile,
    isFunction = _index28.default.isFunction,
    isAsyncFunction = _index28.default.isAsyncFunction,
    isEmptyObject = _index28.default.isEmptyObject,
    isEmptyValue = _index28.default.isEmptyValue;
exports.type = type;
exports.isArray = isArray;
exports.isString = isString;
exports.isNumber = isNumber;
exports.isUndefined = isUndefined;
exports.isObject = isObject;
exports.isDate = isDate;
exports.isFile = isFile;
exports.isFunction = isFunction;
exports.isAsyncFunction = isAsyncFunction;
exports.isEmptyObject = isEmptyObject;
exports.isEmptyValue = isEmptyValue;

addValueForObject(_index28.default);

// string 相关
var autoFillUrl = _index30.default.autoFillUrl;
exports.autoFillUrl = autoFillUrl;

addValueForObject(_index30.default);

// 兼容旧的模块导出 begin
var array = exports.array = _index2.default;
exportDefaultData.array = array;
var functionModule = exports.functionModule = _index12.default;
exportDefaultData.functionModule = functionModule;
var uniqueId = exports.uniqueId = _index14.default.getUniqueId;
exportDefaultData.uniqueId = uniqueId;
var string = exports.string = _index26.default;
exportDefaultData.string = string;
var url = exports.url = _index30.default;
exportDefaultData.url = url;

var utils = exports.utils = _abandon_and_compat2.default;
exportDefaultData.utils = utils;
var dom = exports.dom = _abandon_and_compat2.default.dom;
exportDefaultData.dom = dom;
var date = exports.date = _abandon_and_compat2.default.date;
exportDefaultData.date = date;
var ie = exports.ie = _abandon_and_compat2.default.ie;
exportDefaultData.ie = ie;
var browser = exports.browser = ie;
exportDefaultData.browser = browser;
// 兼容旧的模块导出 end

exports.default = exportDefaultData;